
import "vux";
import { SaafHeader, SaafScroller } from "@/common/components/index";
import { mapState } from "vuex";
import { fetchTool } from "@/common/index";
import { api as apiPage } from "@/page/index";
import { service, nativeApi } from "@/common/index";
import { Dialog, Notify } from "vant";
import { fetch } from "@/page/index";
import md5 from 'vux/src/tools/md5/index.js'

import CryptoJS from "crypto-js"

export default {
data() {
return {
viewHeight: service.getViewHeight(service.componentHeight().native),
page: service.pageServer.newPage(),
list: [],
userObj: {


userName: "",
pwd: "",
verificationCode: "",
lan: "CN",
domain: "http://127.0.0.1:8984",
},
checked: true,
verificationSrc: "",

};
},
components: {
SaafHeader,
SaafScroller,
Dialog,
},
computed: {
...mapState({
userInfo: (state) => state.user.userInfo,
menus: (state) => state.user.menus,
}),
},
created() {


this.requestVerifySrc();
this.listLookupValues();

localStorage.removeItem("routeParentParams")

},
mounted() {

let code = this.getUrlParam('code');
if(code){
this.wxLogin(code);
}
},
activated: function () {
this.findList();
},
methods: {

autoLogin() {
console.log(this.userInfo)
if (!!this.userInfo && !!!this.userInfo.userName) {
this.userObj.userName = this.userInfo.userName
this.userObj.pwd = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(this.userInfo.encryptPwd))
this.onSubmit({})
}
},
findList(p) {
if (p === 0) {
this.$refs.SaafScroller.scrollTo(0, 0, 0);
this.page = service.pageServer.newPage();
}
},
listLookupValues() {
fetch.baseLookupTypeService_findDic().then(res=>{
localStorage.setItem("lookupValues", JSON.stringify(res.data));
this.$store.commit('SET_DIC_CODES', res.data)
})
},
onSubmit(values) {
if (!this.checked) {
Dialog.alert({ message: "请先阅读并同意《协议》" });
return;
}
fetch.login({
userName: this.userObj.userName,
pwd: md5("" + this.userObj.pwd + "lo0.1l@g9v#"),
verificationCode: this.userObj.verificationCode,
lan: this.userObj.lan,
domain: this.userObj.domain,
}).then((res) => {
if (res.code === "S") {
this.initLogin(res)
}
});
},
requestVerifySrc() {
fetch.generateRandomValidate({
lan: this.userObj.lan,
}).then((res) => {
console.log(res);
if (res.status === "S") {
if (res.code === "S") {
this.verificationSrc = res.data;
}
}
});
},
requestMenu(list) {
let _path = false;
let _routePush = () => {
this.$router.push("/TabPage");
_path = true
}
const mobileList = list.filter((item) => item.systemCode === "MOBILE");
mobileList.forEach((item, index) => {
if (index === 0) {
this.$store.commit("SET_RESPONSIBILITY", item.responsibilityId);
}
fetch.findBaseMenuByRespId({
lan: item.lan,
isValid: true,
systemCode: item.systemCode,
responsibilityId: item.responsibilityId,
}).then((res) => {
if (res.code === "S") {
const menu = res.data;
this.$store.commit("ADD_MENU", {
key: item.responsibilityId,
value: menu,

});
setTimeout(() => {
if (!!!_path) {
_routePush()
}
}, 100)
}
});
});

if (mobileList.length === 0 && !!!_path) {
_routePush()
}
},
initLanguage(lanList) {
if (lanList && lanList.length != 0) {
this.$store.commit("SET_LANGUAGE", lanList[0].lookupCode);
}
},
onProtocol() {
Dialog.alert({
title: "协议",
message: `赛意SRM系统平台致力于构建公开、透明的合作环境，平等、高效的协同互通。用户进入赛意SRM系统平台，必须完全、严格遵守本网站相关条款，包括本服务条款。

用户通过点击服务条款中的“我同意”按钮，并且完成赛意SRM系统平台用户注册程序，表示用户与赛意SRM系统平台网站管理单位达成注册用户服务使用协议，接受赛意SRM系统平台注册用户服务条款全部内容。用户通过点击网站其它相关位置上的“我同意”按钮，亦表示完全接受了该按钮相关文件中的全部内容。

在申请使用赛意SRM系统平台提供的服务时，向赛意SRM系统平台提供真实、准确、完整的单位和/或个人资料。`,
});
},
getUrlParam(paramName) {

let params = window.location.search

if (params.indexOf(paramName) > -1) {
let paramValue = ''
paramValue = params.substring(params.indexOf(paramName), params.length)

if (paramValue.indexOf('&') > -1) {

paramValue = paramValue.substring(0, paramValue.indexOf('&'))

paramValue = paramValue.replace(paramName + '=', '')
return paramValue
}
return ''
}
},
wxLogin(code) {
fetch.wechat_login({
lan: this.userObj.lan,
domain: this.userObj.domain,
code: code,
}).then((res) => {
localStorage.wxCode = code;
if (res.data) {
this.initLogin(res)
}
});
},
/**初始化登录后信息*/
initLogin(res) {
const userInfo = res.data;

const userJson = userInfo ? JSON.stringify(userInfo) : "";
localStorage.setItem("userInfo", userJson);
localStorage.removeItem("redirect")
this.$store.commit("INIT_USER_INFO");
if (!!userInfo) {
this.requestMenu(userInfo.userRespList);
this.initLanguage(userInfo.languageList);
}
},
wexAuthorize() {
let _redirectFlag = localStorage.getItem("redirect")
if (!!!_redirectFlag) {
let _authorize = "http://zhaocai.cnispcloud.cn/mobilewx"
let _wechatUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx177d11fa4c327f6b&redirect_uri="
_wechatUrl += encodeURIComponent(_authorize)
_wechatUrl += "&response_type=code&scope=snsapi_base&state=cnisp&connect_redirect=1#wechat_redirect"
window.location.href = _wechatUrl
localStorage.setItem("redirect", "wechatRedirect")
}
/*fetchTool.getBasics(_wechatUrl).then(res => {
Notify({ type: 'success', message: res.data });
})*/
}
},
watch: {},
};



// WEBPACK FOOTER //
// ./src/page/srm/login/login.vue